

export class LetterTemplateViewModel {

  isTypeTemplate: 'firm' | 'master';
  isEditMode: boolean;
  templateData: any;
  s3FilePath: string;
  routingName: string;
  isDefaultTemplate: 0 | 1;
  subTemplateType: 'letter' | 'management' = 'letter';
}
export class copyFileS3Model {
  readonly status: number = 0;
  readonly sourceFolder: string = 'Engagements/masterTemplate';
  readonly module: number = 11;
  readonly folderName: string = "UserTemplate";
  destinationFolder: string;
  fileName: string;
  destFileName: string;
  firmId: number;
  appSyncId: number;
  signatureKey: string;
}

export class DuplicateFileS3Model {
  readonly status: number = 0;
  readonly module: number = 11;
  readonly folderName: string = "UserTemplate";
  sourceFolder: string;//same as destinationFolder -->Folder path in s3
  destinationFolder: string;//same as sourceFolder -->Folder path in s3
  signatureKey: string; //same as sourceFolder,destinationFolder --> Folder path in s3
  fileName: string; //same as destFileName --> Filename to saved in s3
  filenames: string[];// Saving Multiple files in S3
  destinationFileNames: string[]; // Saving Multiple files in S3
  destinationFileName: string;//same as fileName --> Filename to saved in s3
  firmId: number;
  appSyncId: number; //loginId
}

export class updateTemplateIdModel {
  FirmTemplateID: number;
  TemplateName: string;
  JsonFileName: string;
  JsonFilePath: string;
  loginid: number;
}

export class deleteLetterTModel {
  FirmTemplateID: number;
  templatefolderid?: number;
  loginid: number;
  from?:'Engagement' | 'Letter' |'Worksheet';
}

export class MoveTemplateModel {
  templateFolderId: number;
  loginId: number;
  firmTemplateId: number;
  templateName: string;
}

export class EditDisableModel {
  firmTemplateId: number;
  isEditMode: boolean;
}

export class RenameFolderModel {
  templatefolderid: number;
  foldername: string;
  loginid: number;
}

export class AutoStringElements {
  canadaElements: string[] = [
    "Date Picker",
    "Date",
    "Engagement Letter Date",
    "Entity Name",
    'Addresse - Management',
    'Addresse - Board of directors',
    'Addresse - Shareholders',
    "Year end date (CY)",
    "Year end date (PY)",
    "Note X",
    "Client City",
    "City, Province",
    "Complete address",
    "Street Address",
    'Firm address',
    "Postal Code",
    "First Name",
    "Last Name",
    "Balance Sheet",
    'Statement of income and Retained Earnings',
    'Firm Name',
    'Firm Signature',
    'Client Signature',
    'Client Signed Date',
    'Partner Name'
  ]
  usReviewElements: string[] = [
    "Date Picker",
    "Date",
    "Entity Name",
    "Engagement Letter Date",
    'Addresse - Management',
    'Addresse - Board of directors',
    'Addresse - Shareholders',
    "Year end date (CY)",
    "Year end date (PY)",
    "Note X",
    "Client City",
    "City,State",
    "Complete address",
    "Street Address",
    'Firm address',
    "Postal Code",
    "First Name",
    "Last Name",
    "Balance Sheet",
    "Statement of income and Retained Earnings",
    "Statement of cashflow",
    "Statement of changes in stockholders equity",
    'Firm Name',
    "Firm Signature",
    'Client Signature',
    'Client Signed Date',
    'Partner Name'
  ]
}
